import { render, staticRenderFns } from "./KeywordSpottingFilter.vue?vue&type=template&id=39afe851&"
import script from "./KeywordSpottingFilter.vue?vue&type=script&lang=ts&"
export * from "./KeywordSpottingFilter.vue?vue&type=script&lang=ts&"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./KeywordSpottingFilter.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mfe-shared/mfe-shared/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39afe851')) {
      api.createRecord('39afe851', component.options)
    } else {
      api.reload('39afe851', component.options)
    }
    module.hot.accept("./KeywordSpottingFilter.vue?vue&type=template&id=39afe851&", function () {
      api.rerender('39afe851', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/KeywordSpottingFilter.vue"
export default component.exports